import { jobsQueryKeys as jobsBaseQueryKeys } from '@eigtech/ui-shared-jobs'
import { portalsQueryKeys } from '../portals'

export const jobsQueryKeys = {
  ...jobsBaseQueryKeys,
  list: () => [...portalsQueryKeys.listActive(), 'jobs'],
}
